import React from 'react';
import { useLocation } from 'react-router-dom';
import config from '../config';


const MainMenu = ({ toggleMobileNav }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Define all menu items including dropdown
  const menuItems = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About Us" },
    { 
      path: "#", 
      label: "Departments",
      submenu: [
        { path: "/applied-behavioral-analysis", label: "Applied Behavioral Analysis" },
        { path: "/speech-language-pathology", label: "Speech Language Pathology" },
        { path: "/occupational-therapy", label: "Occupational Therapy" },
        { path: "/special-eduaction", label: "Special Education" },
      
      ]
    },
    { 
      path: "#", 
      label: "Programs",
      submenu: [
        { path: "/early-intervention-program", label: "Early Intervention" },
        { path: "/school-readiness-program", label: "School Readiness" },
        { path: "/caregiver-coaching-program", label: "Caregiver Coaching" },
        { path: "/group-and-social-skills-program", label: "Group And Social Skills" },
        { path: "/parent-counselling-program", label: "Parent Counselling" },
      ]
    },
   
   { path: "/our-team", label: "Our Team" },
   { 
    path: "#", 
    label: "Beyond Therapy",
    submenu: [
      { path: "/blogs", label: "Blogs" },
      { path: "/events", label: "Events" },
      // { path: "/testimonials", label: "Testimonials" },
      { path: "/achievements", label: "Achievements" },
    ]
  },
  { 
    path: "/gallery", 
    label: "Gallery",
  },
   { 
    path: "#", 
    label: "Our Branches",
    submenu: [
      { path: "/RHCA-hosur", label: "RHCA - Hosur" },
      { path: "/RHCA-electronic-city", label: "RHCA - Electronic City" },
    ]
  },
  ];

  // Check if a path is active
  const isActive = (path) => {
    return currentPath === path;
  };

  // Check if a dropdown should be marked as active
  const isDropdownActive = (submenuItems) => {
    return submenuItems.some(item => currentPath === item.path);
  };

  return (
    <nav className="main-menu">
      <div className="main-menu__wrapper">
        <div className="main-menu__wrapper-inner">
          <div className="main-menu__logo">
            <a href="/"><img src={`${config.baseUrl}/assets/images/rohlogo.png`}  alt="" width={110} /></a>
            <a href="/"><img src={`${config.baseUrl}/assets/images/rohmobile-Logo.png`}  alt="" width={250} /></a>

          </div>
          <div className="main-menu__btn-box">
            <a href="/contact">Make an Enquiry</a>
          </div>
          <div className="main-menu__wrapper-inner-content">
            <div className="main-menu__top">
              <div className="main-menu__top-inner">
                <div className="main-menu__top-left">
                  <ul className="list-unstyled main-menu__contact-list">
                    <li>
                      <div className="icon">
                        <i className="fas fa-clock"></i>
                      </div>
                      <div className="text">
                        <p>Mon to Fri: 9:00am to 4:30pm</p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-envelope"></i>
                      </div>
                      <div className="text">
                        <p><a href="mailto:rayofhope@acaindia.org">rayofhope@acaindia.org</a></p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-map-marker"></i>
                      </div>
                      <div className="text">
                        <p>Asian Christian Academy,Hosur</p>
                      </div>
                    </li>
                  </ul>
                  <ul className="list-unstyled main-menu__top-menu">
                    <li><a href="/about-us">About</a></li>
                    <li><a href="/faq">FAQs</a></li>
                    <li><a href="/contact">Contact</a></li>
                  </ul>
                </div>
                <div className="main-menu__top-right">
                  <div className="main-menu__social">
                     <a href="https://youtube.com/@rhca-india?si=Pu2jro4V4E-xB_l_" target='_blank'  rel="noopener noreferrer"><i class="fab fa-youtube"></i></a>
                                <a href="https://www.facebook.com/rayofhopeACA?mibextid=rS40aB7S9Ucbxw6v" target='_blank'  rel="noopener noreferrer"><i class="fab fa-facebook"></i></a>
                                <a href="https://www.linkedin.com/company/ray-of-hope-center-for-autism/" target='_blank'  rel="noopener noreferrer"><i class="fab fa-linkedin"></i></a>
                                <a href="https://www.instagram.com/rhcahosur?igsh=dmV5ZHA2czhsNWlv" target='_blank'  rel="noopener noreferrer"><i class="fab fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div className="main-menu__bottom">
              <div className="main-menu__bottom-inner">
                <div className="main-menu__main-menu-box">
                  <a href="#" className="mobile-nav__toggler" onClick={toggleMobileNav}>
                    <i className="fa fa-bars"></i>
                  </a>
                  <ul className="main-menu__list">
                    {menuItems.map((item, index) => (
                      <li 
                        key={index} 
                        className={`
                          ${isActive(item.path) ? 'current' : ''}
                          ${item.submenu ? 'dropdown' : ''}
                          ${item.submenu && isDropdownActive(item.submenu) ? 'current' : ''}
                        `}
                      >
                        <a href={item.path}>{item.label}</a>
                        {item.submenu && (
                          <ul className="sub-menu">
                            {item.submenu.map((subItem, subIndex) => (
                              <li 
                                key={subIndex} 
                                className={isActive(subItem.path) ? 'current' : ''}
                              >
                                <a href={subItem.path}>{subItem.label}</a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="main-menu__right">
                  <div className="main-menu__call">
                    <div className="main-menu__call-icon">
                      <span className="icon-phone-call"></span>
                    </div>
                    <div className="main-menu__call-content">
                      <p className="main-menu__call-sub-title">Have Question?</p>
                      <h5 className="main-menu__call-number">
                        <a href="tel:04344255800,878">04344-255800 (Ext.878)</a>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MainMenu;